import { Helmet } from "react-helmet-async";

const SeoMeta = ({
  title,
  description,
  url,
  image = "https://grcpulse.in/images/default-banner.png",
  type = "website",
  twitterCardType = "summary_large_image",
  canonical,
  siteName = "GRC@Pulse",
  schemaJSONLD,
}) => {
  const schemaString = schemaJSONLD ? JSON.stringify(schemaJSONLD) : null;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical || url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />

      <meta name="twitter:card" content={twitterCardType} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemaString && (
        <script type="application/ld+json">{schemaString}</script>
      )}
    </Helmet>
  );
};

export default SeoMeta
